import React, { useEffect, useRef, useState, useMemo } from 'react';

import IntroClosingSound from './sounds/intro-closing.mp3';
import IntroOpeningSound from './sounds/intro-opening.mp3';

import { useSoundStatus } from '../../../../context/SoundStatusContext';

import './styles.css';

export default function Intro({
  leftTitle,
  leftSubtitle,
  leftDescription,
  rightTitle,
  rightSubtitle,
  rightDescription,
  sidesToClose = false,
  onShowingCompleted,
  isContentCentered = false,
  isSubtitleContentReversed = false
}) {
  const { soundStatus } = useSoundStatus();

  const introClosingEffect = useRef(new Audio(IntroClosingSound));
  const introOpeningEffect = useRef(new Audio(IntroOpeningSound));
  
  const [isShowingCompleted, setIsShowingCompleted] = useState(false);

  useEffect(() => {
    if(sidesToClose && soundStatus === 'enabled') {
      introClosingEffect.current.play().catch(e => console.log('Error playing intro closing sound:', e));
    }
  }, [sidesToClose, soundStatus]);

  const formatSubtitleWithBullets = (text) => {
    if (!text) return '';
    const parts = text.split('/').filter(part => part.trim() !== '');
    if (parts.length <= 1) return text;
    
    const firstPart = parts[0];
    const restParts = parts.slice(1).map(part => 
      `<br/><span class="bullet">•</span> ${part.trim()}`
    ).join('');
    
    return `${firstPart}${restParts}`;
  };

  useEffect(() => {
    const showingCompletedTimer = setTimeout(() => {
      setIsShowingCompleted(true);
      if (soundStatus === 'enabled') {
        introOpeningEffect.current.play().catch(e => console.log('Error playing intro opening sound:', e));
      }

      const onShowingCompletedTimer = setTimeout(() => {
        if (onShowingCompleted) {
          onShowingCompleted();
        }
      }, 900);

      return () => clearTimeout(onShowingCompletedTimer);
    }, 5000);

    return () => clearTimeout(showingCompletedTimer);
  }, [soundStatus, leftTitle]);

  const leftSideClass = sidesToClose 
    ? "intro-side-left-join"
    : isShowingCompleted 
      ? "intro-side-left-slide-out"
      : "";
  
  const rightSideClass = sidesToClose 
    ? "intro-side-right-join"
    : isShowingCompleted 
      ? "intro-side-right-slide-out"
      : "";

  return (
    <div className="intro-wrapper">
      <div className={`intro-side intro-side-left ${leftSideClass}`}>
        <div className="intro-content-container">
          <div className={`intro-content ${isContentCentered ? ' centered' : ''}`}>
            {
              leftTitle &&
                <h1>{leftTitle}</h1>
            }
            <div className={`intro-subtitle-description ${isSubtitleContentReversed ? ' reversed' : ''}`}>
              {
                leftSubtitle &&
                  <h2 dangerouslySetInnerHTML={{ __html: formatSubtitleWithBullets(leftSubtitle) }}></h2>
              }
              {
                leftDescription &&
                  <span className="description" dangerouslySetInnerHTML={{ __html: leftDescription }}></span>
              }
            </div>
          </div>
        </div>
      </div>
      <div className={`intro-side intro-side-right ${rightSideClass}`}>
        <div className="intro-content-container">
          <div className={`intro-content ${isContentCentered ? ' centered' : ''}`}>
            {
              rightTitle &&
                <h1>{rightTitle}</h1>
            }
            <div className={`intro-subtitle-description ${isSubtitleContentReversed ? ' reversed' : ''}`}>
              {
                rightSubtitle &&
                  <h2 dangerouslySetInnerHTML={{ __html: formatSubtitleWithBullets(rightSubtitle) }}></h2>
              }
              {
                rightDescription &&
                  <span className="description" dangerouslySetInnerHTML={{ __html: rightDescription }}></span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
